export default __webpack_public_path__ + "static/media/after_promo.e9676d7c.webp";